<template>
    <b-tab :title="$tc('message.medicalAdvice',1)" v-if="can" :active="pathHas($tc('message.medicalAdvice',1))">
        <b-card-body>
            <div class="timeline"> <!-- v-if="mMedicalAdvices.length > 0"-->
                <div class="timeline-month">
                    {{ $t('message.medicalAdvice') }} {{ $t('message.validated') }}
                </div>
                <div v-for="(medicalAdvice, key) in this.file.avis" :key="key"> <!-- -->
                    <!--                                            v-if="medicalAdvice.avis"-->
                    <div class="timeline-section">
                        <div class="timeline-date">
                            {{ formattedDateTime(medicalAdvice.medecin_avis[0].set_opinion_at) }} <!-- displayDate(medicalAdvice.medecin_avis[0].set_opinion_at) -->
                        </div>
                        <div class="row">
                            <div v-for="(adviceDoctor, keyG) in medicalAdvice.medecin_avis" :key="keyG" class="col-md-10 col-sm-6">
                                <div class="timeline-box">
                                    <div class="box-title">
                                        <i class="fa fa-check text-success" aria-hidden="true"></i>
                                        {{adviceDoctor.medecin.nom + ' ' + adviceDoctor.medecin.prenom}}
                                    </div>
                                    <div class="box-content">
                                        <div class="box-item row">
                                            <p class="box-item-label col-md-3">
                                                {{ $t('message.description') }}
                                            </p>
                                            <p class="box-item-content col-md-9" v-html="medicalAdvice.description">
                                            </p>
                                        </div>
                                        <div class="box-item row" v-if="adviceDoctor.avis">
                                            <p class="box-item-label col-md-3">
                                                {{ `${$t('message.response')}` }}
                                                <span>{{ adviceDoctor.medecin.nom + ' ' + adviceDoctor.medecin.prenom }}</span>
                                            </p>
                                            <p class="box-item-content col-md-9" v-html="adviceDoctor.avis">
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- <p v-else class="mt-2">
                <i>{{ $t('message.noResponseOfMedicalAdviceValidated') }}</i>
                {{ mMedicalAdvices }}
            </p> -->
        </b-card-body>
    </b-tab>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from "moment";
export default {
    name: "MedicalAdvice",
    computed: {
        ...mapGetters(["file", "medicalAdvices"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        can: function () {
            return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
        },
        mMedicalAdvices: function () {
            console.log(this.file);
            // _.forEach(this.medicalAdvices, function(medicalAdvice) {
            //     console.log(medicalAdvice);
            // })
            let patientMedicalAdvices = this.medicalAdvices.filter(medicalAdvice => {
                console.log(medicalAdvice);
                if(medicalAdvice.dossier !== null){
                    console.log(medicalAdvice.dossier.patient_id);
                    console.log(this.file.patient_id);
                }
                if(medicalAdvice.dossier !== null){
                  return  medicalAdvice.dossier.patient_id == this.file.patient_id
                }
            });
            console.log(patientMedicalAdvices);
            // return patientMedicalAdvices;
            // //console.log('a patientMedicalAdvices => ', patientMedicalAdvices);

            // patientMedicalAdvices = patientMedicalAdvices.map(p => {
            //     return {
            //         ...p,
            //         medecin_avis: p.medecin_avis.filter(doctorAdvice => doctorAdvice.set_opinion_at !== 'NULL')
            //     }
            // }).filter(p => p.medecin_avis.length > 0);

            // console.log('b patientMedicalAdvices => ', patientMedicalAdvices);

            // return patientMedicalAdvices;
        }
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasGestionnaireRole', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        getListOfMedicalAdvices(){
            this.$store.dispatch('getMedicalAdvices', {args: {}});
        },
        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        notEmpty(item) {
            return item.length > 0;
        },
    },
    mounted() {
        if (this.can) {
            this.getListOfMedicalAdvices();
        }
    }
}
</script>
<style lang="">
    
</style>